module.exports = __webpack_public_path__ + "img/SITCON-taton-cliped.ffcb41fe.svg";